import React, { useEffect, useState, useRef } from "react";
import iconDots from "url:shared-assets/icons/dots-horizontal.svg";
import iconDotsVertical from "url:shared-assets/icons/dots-vertical.svg";

interface PopItemInterface {
  title: string;
  click: Function;
  img?: React.ReactNode;
}

interface Props {
  items: PopItemInterface[];
  noHover?: boolean;
  isVerticalDots?: boolean;
}

// @ts-ignore
const DotsPopup: React.FC<Props> = ({ items, close, noHover, isVerticalDots }: Props) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const closeFunction = () => {
    setOpen(false);
  };

  useEffect(() => {
    window.addEventListener("resize", closeFunction);
    return () => {
      window.removeEventListener("resize", closeFunction);
    };
  }, []);

  const calculateStyle = () => {
    const style = {
      position: "absolute",
      boxShadow: "3px 6px 6px 0px rgba(25, 25, 60, 0.70)",
      top: "unset",
      left: "unset",
      right: "unset",
      bottom: "unset",
    };
    const width = window.innerWidth;
    const height = window.innerHeight;
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const clientHeight = rect.height;
      const clientWidth = rect.width;
      const fromLeft = rect.left;
      const fromTop = rect.top;
      let x: number;
      let y: number;
      if (width - fromLeft < 200) {
        // If element is to the left or has too little space to the right, align left
        x = width - fromLeft;
        style["right"] = x - clientWidth + "px";
      } else {
        x = fromLeft;
        style["left"] = x + "px";
      }

      if (height - fromTop < 200) {
        // If element is below middle or has too little space beneath, align from bottom
        y = height - fromTop - 2;
        style["bottom"] = y + "px";
      } else {
        y = fromTop + clientHeight - 2;
        style["top"] = y + "px";
      }
    }
    return style;
  };

  let style = {};
  if (open) {
    style = calculateStyle();
  }

  const itemClick = (item: PopItemInterface) => {
    if (item.click) {
      item.click();
    }
  };

  return (
    <div
      className="cursor-pointer relative gap-2"
      ref={containerRef}
      onClick={(e) => setOpen(!open)}
    >
      <div className="hover:bg-indigo-700 rounded-[20px] p-1">
        {isVerticalDots ? (
          <img className="icon" alt="Options" src={iconDotsVertical} />
        ) : (
          <img className="icon" alt="Options" src={iconDots} />
        )}
      </div>
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "calc(100vw - 1px)",
            height: "100vh",
            zIndex: 1001,
            backgroundColor: "rgba(0, 0, 0, 0)",
          }}
          onClick={closeFunction}
        >
          <div className="bg-indigo-800 rounded shadow-gray-600" style={style}>
            {items.map((item, index) => (
              <div key={"item_" + index}>
                {index > 0 && <hr className="border-indigo-700" />}
                <div
                  className="flex items-center px-4 py-2 text-gray-300 cursor-pointer hover:bg-indigo-600 hover:text-white hover:rounded"
                  onClick={() => itemClick(item)}
                >
                  {item.img && <div className="mr-2">{item.img}</div>}
                  <p>{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DotsPopup;
